/**
 * Setzt bei jedem Seitenaufruf das Warenkorb-Attribut `current-date` auf den Zeitstempel des
 * Browsers, wie das Broadcast-Theme bis 07.10.2026 (`assets/theme.dev.js`, Anpassung F20 in
 * `docs/inventory/customizations.md` im Repo elli). Das Attribut landet in der Bestellung.
 *
 * Im Theme liest es niemand. Ob ERP oder ChannelAdvisor es lesen, ist offen; bis das geklärt ist,
 * bleibt es wie vorher. Der Wert ist wie im alten Theme ein ISO-Zeitstempel in UTC
 * (`JSON.stringify(new Date())`). Statt `/cart` nutzt die Datei den dokumentierten Endpunkt
 * `/cart/update.js` mit Sprachpfad.
 */
fetch(`${Theme.routes.cart_update_url}.js`, {
  method: 'POST',
  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
  body: JSON.stringify({ attributes: { 'current-date': new Date() } }),
}).catch(() => {
  // Ohne Netz bleibt das Attribut auf dem letzten Stand, wie im alten Theme.
});
